import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import DocuSignBadge from './DocuSignBadge';
import docusignLogo from './docusign-logo.svg';

const DocuSignConnectCard = ({ isConnected, accountLabel, connectUrl, onConnectClick }) => (
	<Box
		className='docusign-connection-panel'
		border='default'
		borderRadius='md'
		p={3}
	>
		<Box display='flex' alignItems='center' mb={2} gap={2}>
			{/* <img src={docusignLogo} alt='Docusign' className='docusign-logo' height={20} /> */}
			<strong>Docusign</strong>
			{isConnected
				? <DocuSignBadge variant='connected' />
				: <DocuSignBadge variant='not_connected' />}
		</Box>

		{isConnected ? (
			<>
					{accountLabel && (
					<p className='text-muted small mb-0'>{gettext('Account Name:')} {accountLabel}</p>
				)}

				<p className='text-muted small mt-2 mb-0'>
					{gettext('Users can sign when they reach this question')}
				</p>
				<p className='text-muted small mt-2 mb-0'>
					<strong>{gettext('Notes:')}</strong>
				</p>
				<p className='text-muted small mb-0' style={{ paddingLeft: '12px' }}>{'• '}{gettext('Once an applicant submits this form with Docusign, admins can no longer edit it.')}</p>
				<p className='text-muted small mb-0' style={{ paddingLeft: '12px' }}>{'• '}{gettext("Media uploads won't show up in Docusign. Additionally, form content submitted to Docusign will be restricted to 50 MB in size.")}</p>
			</>
		) : (
			<>
				{/* <p className='text-muted small mb-3'>
					{gettext('Effortlessly collect signatures on forms')}
				</p>
				<p className='text-muted small mt-2 mb-0'>
					{gettext('Note: Form fillers will be redirected to Docusign to sign when they reach this question.')}
				</p> */}
			</>
		)}
	</Box>
);

DocuSignConnectCard.propTypes = {
	isConnected: PropTypes.bool.isRequired,
	accountLabel: PropTypes.string,
	connectUrl: PropTypes.string,
	onConnectClick: PropTypes.func,
};

DocuSignConnectCard.defaultProps = {
	accountLabel: '',
	connectUrl: '',
	onConnectClick: null,
};

export default DocuSignConnectCard;
